import React from 'react';
import { useParams } from 'react-router-dom';

import MenuUpsellContainer from 'base-ordering/containers/MenuUpsellContainer';
import { useGetUpsellItems } from 'catering/hooks';
import { useCart } from 'catering/hooks/query';
import { useCateringLocationInventory } from 'catering/hooks/query/location/index';
import { useGoToMenuUpsellItem } from 'catering/hooks/navigation/useGoToMenuUpsellItem';
import { getDateTimeFromFulfillmentDateAndTime } from 'catering/helpers/dates';
import { aggregateLocationInventory } from 'catering/helpers/aggregateCateringLocationInventory';

const MenuUpsell = () => {
  const { data: cart } = useCart();
  /* Retrieve location inventory so that we could format our menu items with inventory for proper filtering */
  const { locationSlug } = useParams();

  const cartFulfillmentDateTime = getDateTimeFromFulfillmentDateAndTime(
    cart?.fulfillment_date,
    cart?.fulfillment_time
  );

  const {
    data,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage
  } = useCateringLocationInventory({
    locationSlug,
    fulfillmentDateTime: cartFulfillmentDateTime
  });

  let locationInventory = { location_id: '', items: [] };
  if (hasNextPage && !isFetchingNextPage) {
    fetchNextPage();
  } else if (data?.pages) {
    locationInventory = aggregateLocationInventory(data, locationInventory);
  }

  const { isUpsellEnabled, upsellItems } = useGetUpsellItems(
    cart,
    locationInventory
  );
  const goToMenuItem = useGoToMenuUpsellItem();

  return (
    <MenuUpsellContainer
      isUpsellEnabled={isUpsellEnabled}
      upsellItems={upsellItems}
      handleOpenModal={slug => goToMenuItem(slug)}
      isCatering
    />
  );
};

export default MenuUpsell;
